module.exports = __webpack_public_path__ + "img/ic-lianlian-full.b12b4e78.svg";